import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  Settings,
  Bell,
  Building2,
} from 'lucide-react';

/**
 * Centralized Module Configuration
 *
 * This file is the single source of truth for all modules in the application.
 * eComm Notify - User Management System only.
 */

export const moduleConfig = {
  // ============================================
  // USER MANAGEMENT (Admin)
  // ============================================
  backoffice: {
    id: 'backoffice',
    name: 'User Management',
    shortName: 'Admin',
    description: 'User management system',
    basePath: '/admin',
    icon: LayoutDashboard,
    color: 'indigo',
    gradient: 'from-[#f08804] to-[#e88b00]',
    bgHover: 'hover:border-[#f08804] hover:bg-[#FFF9EE]',
    roles: ['admin', 'both'],
    features: ['Users', 'Roles', 'Settings'],
    menuItems: [],
  },
};

/**
 * Get module by ID
 */
export const getModuleById = (moduleId) => {
  return moduleConfig[moduleId] || null;
};

/**
 * Get module by path (detects module from current URL)
 */
export const getModuleByPath = (pathname) => {
  return Object.values(moduleConfig).find((module) =>
    pathname.startsWith(module.basePath)
  );
};

/**
 * Get all modules as array (for iteration)
 */
export const getAllModules = () => {
  return Object.values(moduleConfig);
};

/**
 * Get modules filtered by role
 */
export const getModulesForRole = (userRole, hasRoleFn) => {
  return Object.values(moduleConfig).filter((module) => {
    if (!userRole) return true;
    return module.roles.some((role) => hasRoleFn(role));
  });
};

/**
 * Get modules with access status based on enabled modules list
 */
export const getModulesWithAccess = (enabledModules = []) => {
  return getAllModules().map(module => ({
    ...module,
    isEnabled: enabledModules.includes(module.id),
    isLocked: !enabledModules.includes(module.id),
  }));
};

/**
 * Get operations modules
 */
export const getOperationsModules = () => {
  return ['backoffice'].map(id => moduleConfig[id]).filter(Boolean);
};

/**
 * Get management modules
 */
export const getManagementModules = () => {
  return ['backoffice'].map(id => moduleConfig[id]).filter(Boolean);
};

export const getOperationsModulesWithAccess = (enabledModules = []) => {
  return getOperationsModules().map(module => ({
    ...module,
    isEnabled: enabledModules.includes(module.id),
    isLocked: !enabledModules.includes(module.id),
  }));
};

export const getManagementModulesWithAccess = (enabledModules = []) => {
  return getManagementModules().map(module => ({
    ...module,
    isEnabled: enabledModules.includes(module.id),
    isLocked: !enabledModules.includes(module.id),
  }));
};

/**
 * Color scheme mapping for consistent theming
 */
export const moduleColorSchemes = {
  indigo: {
    gradient: 'from-[#f08804] to-[#e88b00]',
    active: 'bg-[#FFF4E6] text-[#C45500]',
    indicator: 'bg-[#232F3E]',
    border: 'border-[#f08804]',
    bg: 'bg-[#FFF4E6]0',
    hover: 'hover:bg-[#232F3E]',
  },
  indigo: {
    gradient: 'from-[#f08804] to-[#e88b00]',
    active: 'bg-[#FFF4E6] text-[#C45500]',
    indicator: 'bg-[#232F3E]',
    border: 'border-[#f08804]',
    bg: 'bg-[#FFF4E6]0',
    hover: 'hover:bg-[#232F3E]',
  },
};

export default moduleConfig;
